import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { Link } from 'react-router-dom';
import { ModelOfFuelType } from 'src/database';
import LoadingScreen from '../../components/LoadingScreen';
import { useListFuelTypesController, } from '../../controllers/FuelType/ListFuelTypesController';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';

const FuelTypesList: React.FC = () => {
    const { getFuelListController, handleFuelListController } = useListFuelTypesController();

    if (getFuelListController.loading) {
        return <LoadingScreen />
    };

    const actionBodyTemplate = (fueltype: ModelOfFuelType) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => handleFuelListController.openEditDialog(fueltype)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleFuelListController.openDeleteDialog(fueltype)} />
            </React.Fragment>
        );
    };

    const editFuelTypeDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleFuelListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getFuelListController.formik.handleSubmit() }} />
        </React.Fragment>
    );

    const deleteFuelTypeDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleFuelListController.closeDeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getFuelListController.selectedFuelType && handleFuelListController.removeFuelType(getFuelListController.selectedFuelType)
                }}
            />
        </React.Fragment>
    );

    const leftFuelTypeToolbar = () => {
        return (
            <Link to="/fueltypeForm">
                <Button label="Cadastrar tipo de combustivel" icon="pi pi-plus" className="p-button-success p-mr-2" />
            </Link>
        );
    };

    return (
        <div>
            <Toast ref={getFuelListController.toast} />
            <div className="p-card p-p-4 datatable-container">
                <Toolbar className="p-mb-4" left={leftFuelTypeToolbar}></Toolbar>

                <DataTable className="p-datatable-sm"
                    dataKey="ID" rowHover scrollable scrollHeight={'100%'}
                    value={getFuelListController.fuelTypesData}>
                    <Column field="DESCRICAO" header="Tipo de combustivel"></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
            </div>

            <Dialog
                className="p-fluid"
                style={{ width: '450px' }}
                visible={getFuelListController.editDialog}
                onHide={handleFuelListController.closeEditDialog}
                onShow={() => getFuelListController.formik.setFieldValue('DESCRICAO', getFuelListController.selectedFuelType?.DESCRICAO)}
                footer={editFuelTypeDialogFooter}
                header={`Editar tipo de combustivel ${getFuelListController.selectedFuelType?.DESCRICAO}`}
                modal
            >
                <div className="p-field">
                    <label htmlFor="description">Nome</label>
                    <InputText id="name" type="text"
                        value={getFuelListController.formik.values.DESCRICAO}
                        onChange={getFuelListController.formik.handleChange('DESCRICAO')}
                        required
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getFuelListController.formik.touched.DESCRICAO && getFuelListController.formik.errors.DESCRICAO,
                        'popup-form-inactive': !(getFuelListController.formik.touched.DESCRICAO && getFuelListController.formik.errors.DESCRICAO),
                    })}
                    >{getFuelListController.formik.errors.DESCRICAO}</div>
                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getFuelListController.deleteDialog}
                onHide={handleFuelListController.closeDeleteDialog}
                footer={deleteFuelTypeDialogFooter}
                header="Remover tipo de combustivel"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getFuelListController.selectedFuelType && <span>Você tem certeza que deseja deletar o tipo de combustivel <b>{getFuelListController.selectedFuelType.DESCRICAO}</b>?</span>}
                </div>
            </Dialog>
        </div>

    );
};

export default FuelTypesList;